// Mock data for EWS Productions website

export const heroSlides = [
  {
    id: 1,
    title: "Film Set Construction",
    description: "Cinematic environments built for your vision",
    bgColor: "#151515",
    textColor: "#ff3225",
    image: "https://customer-assets.emergentagent.com/job_83fea004-6cdd-45cc-8eca-9e308c95c237/artifacts/2bk4xjye_image.png"
  },
  {
    id: 2,
    title: "Fashion & Editorial Studio",
    description: "Dark, atmospheric space for striking imagery",
    bgColor: "#1a0a0f",
    textColor: "#ffd1e7",
    image: "https://images.unsplash.com/photo-1595065666634-4725aa7e8379"
  },
  {
    id: 3,
    title: "Scene Film Production",
    description: "Professional, consent-led creative environments",
    bgColor: "#0a0a0a",
    textColor: "#ff84e4",
    image: "https://images.unsplash.com/photo-1577190651915-bf62d54d5b36"
  }
];

export const services = [
  {
    id: 1,
    title: "Studio Hire",
    description: "Versatile, high-end studio spaces for film, fashion, editorial, and alternative creative productions",
    icon: "Film",
    features: [
      "Adaptable set designs",
      "Professional lighting and rigging",
      "Sound control and privacy",
      "Production support available",
      "Shower room and dressing area"
    ],
    pricing: [
      { package: "Half Day (4 hours)", price: "£400" },
      { package: "Full Day (8 hours)", price: "£700" },
      { package: "Evening Session", price: "£350" }
    ],
    bgColor: "#ff3225"
  },
  {
    id: 2,
    title: "Bespoke Set Design & Construction",
    description: "Custom-built film and photo shoot sets tailored to your creative vision and narrative requirements",
    icon: "Hammer",
    features: [
      "Custom set design & planning",
      "Full construction services",
      "Period-specific environments",
      "Modular & adaptable builds",
      "Set dressing & props"
    ],
    pricing: [
      { package: "Design Consultation", price: "£250" },
      { package: "Small Set Build", price: "£2,500" },
      { package: "Full Production Set", price: "Contact" }
    ],
    bgColor: "#d1903a"
  },
  {
    id: 3,
    title: "Fashion Shoot & Event Hire",
    description: "Exclusive creative space designed for striking visuals and private fashion presentations",
    icon: "Camera",
    features: [
      "Fashion campaigns & editorials",
      "Lookbooks & brand launches",
      "Styled shoots and fittings",
      "Private fashion presentations",
      "Creative industry events"
    ],
    pricing: [
      { package: "Fashion Shoot (4 hours)", price: "£450" },
      { package: "Brand Event (Evening)", price: "£800" },
      { package: "Full Day Campaign", price: "£900" }
    ],
    bgColor: "#ffd1e7"
  },
  {
    id: 4,
    title: "Boudoir & Intimate Photography",
    description: "Professional, tasteful environments for intimate editorial work and personal empowerment photography",
    icon: "Heart",
    features: [
      "Private, discreet sessions",
      "Soft, flattering lighting setups",
      "Editorial boudoir styling",
      "Body-positive atmosphere",
      "Professional respect & boundaries"
    ],
    pricing: [
      { package: "Personal Session (2 hours)", price: "£350" },
      { package: "Couple Session (3 hours)", price: "£500" },
      { package: "Editorial Campaign", price: "£850" }
    ],
    bgColor: "#ff84e4"
  },
  {
    id: 5,
    title: "Scene Film Production",
    description: "Story-driven production with cinematic lighting and professional, consent-first workflows",
    icon: "Video",
    features: [
      "Creative planning & collaboration",
      "Cinematic lighting & mood",
      "Clear boundaries & professionalism",
      "Respectful, consent-first approach"
    ],
    pricing: [
      { package: "Production Day", price: "£750" },
      { package: "Weekend Package", price: "£1,400" },
      { package: "Custom Project", price: "Contact" }
    ],
    bgColor: "#d987ff"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1595065666634-4725aa7e8379",
    category: "Fashion",
    alt: "Dark fashion editorial"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1602509380108-a47060db0a97",
    category: "Fashion",
    alt: "Dramatic portrait"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1645996830739-8fe3df27c33f",
    category: "Editorial",
    alt: "Editorial portrait"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1583208883272-e4eb60f7081d",
    category: "Boudoir",
    alt: "Intimate editorial portrait"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f",
    category: "Boudoir",
    alt: "Fashion boudoir styling"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1509631179647-0177331693ae",
    category: "Boudoir",
    alt: "Sensual fashion photography"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1524638431109-93d95c968f03",
    category: "Editorial",
    alt: "Artistic intimate portrait"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1762028895833-bfcf6c6052cb",
    category: "Production",
    alt: "Studio lighting setup"
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1619850015546-84a1c7b7aed0",
    category: "Production",
    alt: "Cinematic camera equipment"
  },
  {
    id: 10,
    url: "https://images.unsplash.com/photo-1716703433576-13ff2922db95",
    category: "Studio",
    alt: "Studio interior"
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
    category: "Boudoir",
    alt: "Intimate studio portrait"
  },
  {
    id: 12,
    url: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
    category: "Fashion",
    alt: "Fashion editorial styling"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "The studio provided the perfect atmospheric backdrop for our editorial campaign. Professional, discreet, and visually stunning.",
    author: "Creative Director, Fashion House London",
    category: "Fashion"
  },
  {
    id: 2,
    quote: "EWS Productions delivered exceptional set construction and maintained the highest standards of professionalism throughout our shoot.",
    author: "Film Producer, Independent Production",
    category: "Film"
  },
  {
    id: 3,
    quote: "A rare find - a studio that understands alternative creative work while maintaining total discretion and respect.",
    author: "Editorial Photographer",
    category: "Editorial"
  }
];

export const aboutContent = {
  mission: "EWS Productions specializes in creating cinematic environments for film, fashion, and alternative creative productions. Inspired by noir cinema, underground culture, and avant-garde fashion, we provide a professional, discreet space where artistic vision meets technical excellence.",
  values: [
    "Artistic Integrity",
    "Professional Excellence",
    "Consent & Respect",
    "Creative Freedom",
    "Discretion & Privacy"
  ]
};

export const contactInfo = {
  email: "admin@ewsproductions.com",
  phone: "0800 0248635",
  address: "Wembley, London, United Kingdom"
};

export const enquiryTypes = [
  { value: "film", label: "Film Production" },
  { value: "fashion", label: "Fashion Shoot" },
  { value: "boudoir", label: "Boudoir Shoot" },
  { value: "event", label: "Event Hire" },
  { value: "photography", label: "Photography / Video" },
  { value: "other", label: "Other Enquiry" }
];